.divider {
  height: 18px;
}
